import { render, staticRenderFns } from "./TextAndHovertext.vue?vue&type=template&id=10411b57&scoped=true&"
import script from "./TextAndHovertext.vue?vue&type=script&lang=js&"
export * from "./TextAndHovertext.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10411b57",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
